import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MenuItemPath, MenuItem } from '@enums/menu-item.enum';
import { AuthGuard } from 'app/core/guards/auth.guard';
import { TollComponent } from './pages/toll/toll.component';

const routes: Routes = [
    {
      path: MenuItemPath.get(MenuItem.toll),
      component: TollComponent,
      canActivate: [AuthGuard]
    }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
})

export class TollRoutingModule { }
